// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = () => ({
  labelContainer: {
    bgcolor: 'white',
    borderRadius: 1,
    px: 1.5,
    py: 0.75,
    boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
    pointerEvents: 'none',
    whiteSpace: 'nowrap',
  },
  labelTitle: {
    fontWeight: 700,
    fontSize: '12px',
    lineHeight: 1.3,
  },
  labelRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 0.5,
  },
  statusDot: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    flexShrink: 0,
  },
  labelName: {
    fontSize: '11px',
    lineHeight: 1.3,
    color: 'text.secondary',
  },
});

export default styles;
